import {
  CartSettings,
  InjectedCartProps,
  withCartFactory,
} from '@grandvisionhq/www-next/pages/cart/hoc'

export const settings: CartSettings = {
  isDiscountCodeEnabled: true,
  showCartDiscountOnLineItem: true,
  showSubTotal: true,
  showTotalDiscount: true,
  onFinalizedCartError: ({ resetCallback }: { resetCallback: () => void }) => {
    resetCallback()
  },
  onUnRecoverableError: ({ resetCallback }: { resetCallback: () => void }) => {
    resetCallback()
  },
}

export type { InjectedCartProps }

export const withCart = withCartFactory(settings)
